module.exports = __webpack_public_path__ + "static/media/15.c6a59f07.png";